import "./OffCyclePayrollDataGridStyle.css";

import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHF,
	RHookFormNumberField,
	RequestParams,
} from "@websential/cosmic-v20";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {  formatAmountCommaSeperator, formatAmountToFloat, formatDate, formatDateToShow, formatThousandSeperatorWithTwoFixedAmount, getValueByFieldPath } from "../../../common/Common";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import isEqual from "lodash/isEqual";

export interface IOffCyclePayrollDataGrid {
	rows: any;
	columns: any;
	showIndexColumn: boolean;
	showChecboxColumn: boolean;
	onRowDeleteClicked?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	isLoading?: any;
	onSnackbarMessageData?: (value: any) => void;
	onRequestParamsChange?: (params: RequestParams) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	selectionToolbar?: (selectedItems: any) => React.ReactNode;
	selectedRowsValues?: any;
	changeLoginForGetEmptyItemsBySearchQuery?: any;
	searchFieldPlaceholder?: string;
	showGlobalSearch?: boolean;
	tableMargin?: string;
	rowsPerPageOptions?: number[];
	footer?: any;
	whiteSpace?: string;
	requestParamsToInitial?: boolean;
	tableScrollHeight?: boolean;
	pageTitle?: string;
	OffCyclePayrollTableData: (data: any) => void;
	vocationalEarningsList: any
}

export const OffCyclePayrollDataGrid: React.FC<IOffCyclePayrollDataGrid> = ({
	rows,
	columns,
	showIndexColumn,
	showChecboxColumn,
	onRowDeleteClicked,
	onRowEditClicked,
	isLoading,
	onSnackbarMessageData,
	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	selectionToolbar,
	selectedRowsValues,
	searchFieldPlaceholder,
	showGlobalSearch = true,
	tableMargin,
	rowsPerPageOptions,
	changeLoginForGetEmptyItemsBySearchQuery,
	footer,
	whiteSpace,
	requestParamsToInitial,
	tableScrollHeight,
	pageTitle,
	OffCyclePayrollTableData,
	vocationalEarningsList
}) => {
	const isInitialRequest = useRef(true);
	const [loading, setLoading] = useState(false);
	const [offCyclePayrollItems, setOffCyclePayrollItems] = useState<any>(
		rows && rows
	);

	useEffect(() => {
		OffCyclePayrollTableData(offCyclePayrollItems);

	}, [offCyclePayrollItems]);

	useEffect(() => {
		if (!isEqual(rows, offCyclePayrollItems)) {
			setOffCyclePayrollItems([...rows]);
		}
	}, [rows]);

	const theme = useTheme();
	const [itemSearch, setItemSearch] = useState("");
	const [requestParams, setRequestParams] = useState<any>({
		first: initialPage,
		rows: initialPageSize,
		page: initialPage,
		sortField: null,
		sortOrder: "asc",
		searchQuery: "",
		filters: {
			name: { value: "", matchMode: "contains" },
			"country.name": { value: "", matchMode: "contains" },
			company: { value: "", matchMode: "contains" },
			"representative.name": { value: "", matchMode: "contains" },
		},
	});

	const [selectedItems, setSelectedItems] = useState<any>([]);
	const [selectedItemsIds, setSelectedItemsIds] = useState<any>([]);
	const [itemSearsch, setItemSearsch] = useState("");
	const onSearchButtonClicked = () => {
		setLoading(true);
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: itemSearch,
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};
	const handleClearSearch = () => {
		setLoading(true);
		setItemSearch("");
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: "",
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};

	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					// justifyContent:showGlobalSearch ? "space-between" : "end",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				{showGlobalSearch && (
					<span
						className="p-input-icon-left w-3"
						style={{ display: "flex", marginLeft: "10px", height: "37px" }}
					>
						<i className="pi pi-search" />
						<InputText
							value={itemSearch}
							onChange={(e) => setItemSearch(e.target.value)}
							placeholder={
								searchFieldPlaceholder ? searchFieldPlaceholder : "Search..."
							}
							className="w-full"
							style={{ borderRadius: "2px 0px 0px 2px" }}
						/>
						{itemSearch && (
							<Button
								icon="pi pi-times"
								onClick={handleClearSearch}
								className="p-button-warning"
								style={{ borderRadius: 0 }}
							/>
						)}
						<Button
							onClick={onSearchButtonClicked}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
							style={{
								// padding:"8px 10px 8px 10px",
								padding: "10px 22px 10px 10px",
								// marginRight:"-14px!important",
								borderRadius: "0px 2px 2px 0px",
								// backgroundColor: theme.palette.primary.main
							}}
						>
							{/* <SearchIcon /> */}
							Search
						</Button>
					</span>
				)}
				{/* {selectionToolbar && selectionToolbar(selectedItemsIds)} */}
				{selectionToolbar && selectionToolbar(selectedItems)}
			</div>
		);
	};
	const headerSearch = renderHeader();

	const onPage = (event: any) => {
		// setRequestParams(event);
		setLoading(true);
		//imitate delay of a backend call
		setTimeout(() => {
			setRequestParams({
				...event,
				searchQuery: itemSearch,
			});
			setLoading(false);
		}, 1000);
	};
	const [sortField, setSortField] = useState(null);
	const [sortOrder, setSortOrder] = useState(1);
	const onSort = useCallback(
		(event: any) => {
			setLoading(true);

			let newSortOrder: any;
			if (event.sortField === sortField) {
				// Toggle sortOrder between 1 and -1
				newSortOrder = sortOrder === 1 ? -1 : 1;
				setSortOrder(newSortOrder);
			} else {
				// Set the new sortField and reset sortOrder to 1
				newSortOrder = 1;
				setSortField(event.sortField);
				setSortOrder(newSortOrder);
			}


			setRequestParams((prevParams: any) => ({
				...prevParams,
				sortOrder: newSortOrder !== 1 ? "asc" : "desc",
				sortField: event.sortField,
			}));

			// Imitate delay of a backend call
			setTimeout(() => {
				setLoading(false);
			}, 1000);
		},
		[sortOrder, sortField]
	);
	// This useEffect is triggered when the debouncedSearchQuery, pageSize or currentPage values change
	useEffect(() => {
		// if the results fetcher was passed, we can use it to fetch the results.
		if (onRequestParamsChange) {
			// skip the first initial call
			if (isInitialRequest.current === true) {

				isInitialRequest.current = false;
			} else {

				onRequestParamsChange(requestParams);
			}
		}
	}, [onRequestParamsChange, requestParams, requestParamsToInitial]);

	useEffect(() => {
		if (requestParamsToInitial && requestParams.first !== initialPage) {
			setRequestParams({
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				sortField: null,
				sortOrder: "asc",
				searchQuery: "",
				filters: {
					name: { value: "", matchMode: "contains" },
					"country.name": { value: "", matchMode: "contains" },
					company: { value: "", matchMode: "contains" },
					"representative.name": { value: "", matchMode: "contains" },
				},
			});

		}

	}, [requestParamsToInitial, onRequestParamsChange, requestParams]);

	const onSelectionModelChange = useCallback(
		(items: any) => {
			let selectedItemsIds = items.value.map((item: any) => item.id);
			// setSelectedItems(selectedItemsIds);
			// Check for deleted items and remove them from selectedItems
			const updatedSelectedItems = items.value.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
			setSelectedItems(updatedSelectedItems);
			setSelectedItemsIds(selectedItemsIds);
			if (selectedRowsValues) {
				if (items.value.length > 0) {
					const selectedRowData = rows.filter((row: any) => {
						return items.value.includes(row);
					});

					selectedRowsValues(selectedRowData);
				} else {
					selectedRowsValues(items.value);

				}
			}
		},
		[rows, selectedRowsValues, selectedItems]
	);
	// useEffect(() => {
	// 	// Check for deleted items and remove them from selectedItems
	// 	const updatedSelectedItems =
	// 		selectedItems &&
	// 		selectedItems.length > 0 &&
	// 		selectedItems.filter((selectedItem: any) => {
	// 			return rows && rows.find((row: any) => row.id === selectedItem.id);
	// 		});
	// 	// Only update if there are changes to selectedItems
	// 	if (
	// 		updatedSelectedItems &&
	// 		updatedSelectedItems.length !== selectedItems.length
	// 	) {
	// 		setSelectedItems(updatedSelectedItems);

	// 		// Update selectedItemsIds
	// 		const updatedSelectedItemsIds = updatedSelectedItems.map(
	// 			(item: any) => item.id
	// 		);
	// 		setSelectedItemsIds(updatedSelectedItemsIds);
	// 	}
	// }, [rows, selectedItems]);
	useEffect(() => {
		if (selectedItems && selectedItems.length > 0) {
			// Check if all selected items exist in rows
			const allExist = selectedItems.every((selectedItem: any) =>
				rows?.some((row: any) => row.employeeId === selectedItem.employeeId)
			);
			if (!allExist) {
				// ❌ One or more items removed → reset to initial state
				setSelectedItems([]);
				setSelectedItemsIds([]);
				if (selectedRowsValues) selectedRowsValues([]);
			}
		}
	}, [rows]);


	// const onCellValueChange = (column: any, rowIndex: number, value: any) => {

	// 	// setOffCyclePayrollItems((prev: any) => {
	// 	// 	const updatedData = [...prev];
	// 	// 	const updatedRow = { ...updatedData[rowIndex], [event.field]: field };


	// 	// 	updatedData[rowIndex] = updatedRow;
	// 	// 	return updatedData;
	// 	// });
	// };

	let listttt = [
		"grossIncome", //Gross
		"ot1Dot5Hours", //ot 1.5 
		"Commission",
		"Over Time 1.5",
		"Over Time 2.0",
		"Bonus",
		"Non-Periodic Payment",
		"Retroactive Pay Increase",
		"Holiday Pay"
	]

	// const onCellValueChange = (column: any, rowIndex: number, value: any, rowData?: any) => {
	// 	// if (showChecboxColumn) {
	// 	// 	setOffCyclePayrollItems((prev: any[]) => {
	// 	// 		const updatedData = [...prev];
	// 	// 		const updatedRow = { ...updatedData[rowIndex], [column.field]: value };
	// 	// 		updatedData[rowIndex] = updatedRow;

	// 	// 		// Fix: re-map selectedItems to updatedData references
	// 	// 		setSelectedItems((prevSelected: any[]) =>
	// 	// 			prevSelected
	// 	// 				.map(sel => updatedData.find(r => r.id === sel.id))
	// 	// 				.filter(Boolean)
	// 	// 		);

	// 	// 		return updatedData;
	// 	// 	});
	// 	// } else {
	// 	// 	setOffCyclePayrollItems((prev: any[]) => {
	// 	// 		const updatedData = [...prev];
	// 	// 		const updatedRow = updatedData[rowIndex];

	// 	// 		// mutate only the needed field (keeps same object reference)
	// 	// 		updatedRow[column.field] = value;

	// 	// 		return updatedData;
	// 	// 	});
	// 	// }
	// 	if (showChecboxColumn) {
	// 		if (vocationalEarningsList && vocationalEarningsList.length > 0) {
	// 			const isVocationable = vocationalEarningsList.includes(column.field);
	// 			// const isVocationable = vocationalEarningsList.includes("Regular Gross")
	// 		


	// 			setOffCyclePayrollItems((prev: any[]) => {
	// 				const updatedData = [...prev];
	// 				const updatedRow = { ...updatedData[rowIndex] };


	// 				// always update the edited field first
	// 				updatedRow[column.field] = value;

	// 				if (isVocationable) {
	// 					// 1️⃣ Sum all vocational field values (including this one)
	// 					let totalSum = 0;

	// 					vocationalEarningsList.forEach((vocField: string | number) => {
	// 						
	// 						const fieldValue =
	// 							vocField === column.field
	// 								? value
	// 								: Number(updatedRow[vocField]) || 0;
	// 						totalSum += fieldValue;
	// 					
	// 					});
	// 					


	// 					// 2️⃣ Calculate 4% of total
	// 					const calculatedValue = (totalSum * 4) / 100;
	// 					
	// 					if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
	// 						const vacationPayDueField = "vacationPayAccured";
	// 						// const initialRowValue = rows && rows.find((x: any) => x.employeeId === rowData.employeeId)
	// 						// // const existingValue = Number(updatedRow[vacationPayDueField]) || 0;
	// 						// const existingValue = Number(initialRowValue.vacationPayAccured) || 0;
	// 						// if (calculatedValue !== 0) {

	// 						// 	const newValue = existingValue + calculatedValue;
	// 						

	// 						// 	// ✅ Round to 2 decimal places
	// 						// 	updatedRow[vacationPayDueField] = Math.round(newValue * 100) / 100;
	// 						// } else {
	// 						// 	const initialRowValue = rows && rows.find((x: any) => x.employeeId === rowData.employeeId)
	// 						
	// 						// 	updatedRow[vacationPayDueField] = Math.round(initialRowValue.vacationPayAccured * 100) / 100;

	// 						// }

	// 						updatedRow[vacationPayDueField] = Math.round(calculatedValue * 100) / 100;


	// 					} else {
	// 						updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = Math.round(calculatedValue * 100) / 100;



	
	// 						// const vacationPayDueField = "vacationPayAccured";
	// 						// updatedRow[vacationPayDueField] = Math.round(calculatedValue * 100) / 100;
	// 					}
	// 				}

	// 				// Update table data
	// 				updatedData[rowIndex] = updatedRow;

	// 				// Update selected items
	// 				setSelectedItems((prevSelected: any[]) =>
	// 					prevSelected
	// 						.map((sel) => updatedData.find((r) => r.id === sel.id))
	// 						.filter(Boolean)
	// 				);

	// 				return updatedData;
	// 			});
	// 		} else {
	// 			setOffCyclePayrollItems((prev: any[]) => {
	// 				const updatedData = [...prev];
	// 				const updatedRow = { ...updatedData[rowIndex], [column.field]: value };
	// 				updatedData[rowIndex] = updatedRow;

	// 				// Fix: re-map selectedItems to updatedData references
	// 				setSelectedItems((prevSelected: any[]) =>
	// 					prevSelected
	// 						.map(sel => updatedData.find(r => r.id === sel.id))
	// 						.filter(Boolean)
	// 				);

	// 				return updatedData;
	// 			});
	// 		}
	// 	} else {
	// 		setOffCyclePayrollItems((prev: any[]) => {
	// 			const updatedData = [...prev];
	// 			const updatedRow = updatedData[rowIndex];

	// 			// mutate only the needed field (keeps same object reference)
	// 			updatedRow[column.field] = value;

	// 			return updatedData;
	// 		});
	// 	}
	// };
	const onCellValueChange = (column: any, rowIndex: number, value: any, rowData: any) => {
		// if (showChecboxColumn) {
		// 	setOffCyclePayrollItems((prev: any[]) => {
		// 		const updatedData = [...prev];
		// 		const updatedRow = { ...updatedData[rowIndex], [column.field]: value };
		// 		updatedData[rowIndex] = updatedRow;

		// 		// Fix: re-map selectedItems to updatedData references
		// 		setSelectedItems((prevSelected: any[]) =>
		// 			prevSelected
		// 				.map(sel => updatedData.find(r => r.id === sel.id))
		// 				.filter(Boolean)
		// 		);

		// 		return updatedData;
		// 	});
		// } else {
		// 	setOffCyclePayrollItems((prev: any[]) => {
		// 		const updatedData = [...prev];
		// 		const updatedRow = updatedData[rowIndex];

		// 		// mutate only the needed field (keeps same object reference)
		// 		updatedRow[column.field] = value;

		// 		return updatedData;
		// 	});
		// }
	
		if (showChecboxColumn && rowData) {
			const allVocationableEarningsListOfThisEmployeeProvince = [...(vocationalEarningsList.vocationableEarnings[rowData.provinceId] ?? []), ...vocationalEarningsList.edr];
			
			if (allVocationableEarningsListOfThisEmployeeProvince && allVocationableEarningsListOfThisEmployeeProvince.length > 0) {
				if (
					column.field === 'grossIncome' && value !== null && value !== 0
				) {
					
					const isVocationable = allVocationableEarningsListOfThisEmployeeProvince.includes(column.field);

					setOffCyclePayrollItems((prev: any[]) => {
						const updatedData = [...prev];
						const updatedRow = { ...updatedData[rowIndex] };


						// always update the edited field first
						updatedRow[column.field] = value;

						if (isVocationable) {
							// 1️⃣ Sum all vocational field values (including this one)
							let totalSum = 0;

							const notAllowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];

							allVocationableEarningsListOfThisEmployeeProvince.forEach((vocField: string) => {
								// ⛔ Ignore not allowed fields completely
								if (notAllowedFields.includes(vocField)) return;

								
								const fieldValue =
									vocField === column.field
										? Number(value) || 0
										: Number(updatedRow[vocField]) || 0;

								totalSum += fieldValue;
							});

						


							const calculatedValue = (totalSum * 4) / 100;
							if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
								// existing Value or saved employee vac due value
								const initialRowValue = rows && rows.find((x: any) => x.employeeId === rowData.employeeId)
								const existingValue = Number(initialRowValue.vacationPayAccured) || 0;
								const newValue = existingValue + calculatedValue;
								// jb tk umair yaha tk pohanchy ga to existing value b is may add krni ha 
								// so just change line 1 with line 2 in all these scenarios
								// line 1 : updatedRow["vacationPayAccured"] = Math.round(calculatedValue * 100) / 100;
								// line 2 : updatedRow["vacationPayAccured"] = Math.round(newValue * 100) / 100;
								updatedRow["vacationPayAccured"] = Math.round(calculatedValue * 100) / 100;
							} else {
								updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = Math.round(calculatedValue * 100) / 100;
							}
						}
						updatedData[rowIndex] = updatedRow;
						setSelectedItems((prevSelected: any[]) =>
							prevSelected
								.map((sel) => updatedData.find((r) => r.employeeId === sel.employeeId))
								.filter(Boolean)
						);
						return updatedData;
					});
				} else if (
					column.field === 'grossIncome' && value === null || value === 0
				) {
					
					const allowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];
					const isVocationable = allowedFields.some(field =>
						allVocationableEarningsListOfThisEmployeeProvince.includes(field)
					);
					setOffCyclePayrollItems((prev: any[]) => {
						const updatedData = [...prev];
						const updatedRow = { ...updatedData[rowIndex] };


						// always update the edited field first
						updatedRow[column.field] = value;

						if (isVocationable) {
							let totalSum = 0;
							const notAllowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];
							allVocationableEarningsListOfThisEmployeeProvince.forEach((vocField: string) => {
								// ⛔ Ignore not allowed fields completely
								if (notAllowedFields.includes(vocField)) return;

								
								const fieldValue =
									vocField === column.field
										? Number(value) || 0
										: Number(updatedRow[vocField]) || 0;

								totalSum += fieldValue;
							});

							// const calculatedValue = (totalSum * 4) / 100;

							const regularHoursValue = rowData.regularHours && rowData.regularHours !== null ? rowData.regularHours * rowData.hourlyRate : 0;
							const ot1Dot5HoursValue = rowData.ot1Dot5Hours && rowData.ot1Dot5Hours !== null ? rowData.ot1Dot5Hours * rowData.hourlyRate * 1.5 : 0;
							const ot2Dot0HoursValue = rowData.ot2Dot0Hours && rowData.ot2Dot0Hours !== null ? rowData.ot2Dot0Hours * rowData.hourlyRate * 2.0 : 0;
							let grossValue = regularHoursValue + ot1Dot5HoursValue + ot2Dot0HoursValue + totalSum
							const calculatedValue = (grossValue * 4) / 100;
							if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
								// existing Value or saved employee vac due value
								const initialRowValue = rows && rows.find((x: any) => x.employeeId === rowData.employeeId)
								const existingValue = Number(initialRowValue.vacationPayAccured) || 0;
								const newValue = existingValue + calculatedValue;
								updatedRow["vacationPayAccured"] = Math.round(calculatedValue * 100) / 100;
							} else {
								updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = Math.round(calculatedValue * 100) / 100;
							}

						}
						updatedData[rowIndex] = updatedRow;
						setSelectedItems((prevSelected: any[]) =>
							prevSelected
								.map((sel) => updatedData.find((r) => r.employeeId === sel.employeeId))
								.filter(Boolean)
						);
						return updatedData;
					});

				} else if (column.field === 'regularHours' || column.field === 'ot1Dot5Hours' || column.field === 'ot2Dot0Hours') {
					const allowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];
					const isVocationable = allowedFields.some(field =>
						allVocationableEarningsListOfThisEmployeeProvince.includes(field)
					);
					setOffCyclePayrollItems((prev: any[]) => {
						const updatedData = [...prev];
						const updatedRow = { ...updatedData[rowIndex] };


						// always update the edited field first
						updatedRow[column.field] = value;

						if (isVocationable && rowData.grossIncome === null ||
							rowData.grossIncome === "" ||
							rowData.grossIncome === "0.00" ||
							Number(rowData.grossIncome) === 0) {
							if (column.field === 'regularHours') {
								const ot1Dot5HoursValue = rowData.ot1Dot5Hours && rowData.ot1Dot5Hours !== null ? rowData.ot1Dot5Hours * rowData.hourlyRate * 1.5 : 0;
								const ot2Dot0HoursValue = rowData.ot2Dot0Hours && rowData.ot2Dot0Hours !== null ? rowData.ot2Dot0Hours * rowData.hourlyRate * 2.0 : 0;
								let grossValue = (value * rowData.hourlyRate) + ot1Dot5HoursValue + ot2Dot0HoursValue
								const calculatedValue = (grossValue * 4) / 100;
								if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
									// existing Value or saved employee vac due value
									const initialRowValue = rows && rows.find((x: any) => x.employeeId === rowData.employeeId)
									const existingValue = Number(initialRowValue.vacationPayAccured) || 0;
									const newValue = existingValue + calculatedValue;
									updatedRow["vacationPayAccured"] = Math.round(calculatedValue * 100) / 100;
								} else {
									updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = Math.round(calculatedValue * 100) / 100;
								}
							} else if (column.field === 'ot1Dot5Hours') {
								const regularHoursValue = rowData.regularHours && rowData.regularHours !== null ? rowData.regularHours * rowData.hourlyRate : 0;
								const ot2Dot0HoursValue = rowData.ot2Dot0Hours && rowData.ot2Dot0Hours !== null ? rowData.ot2Dot0Hours * rowData.hourlyRate * 2.0 : 0;
								let grossValue = (value * rowData.hourlyRate * 1.5) + regularHoursValue + ot2Dot0HoursValue
								const calculatedValue = (grossValue * 4) / 100;
								if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
									// existing Value or saved employee vac due value
									const initialRowValue = rows && rows.find((x: any) => x.employeeId === rowData.employeeId)
									const existingValue = Number(initialRowValue.vacationPayAccured) || 0;
									const newValue = existingValue + calculatedValue;
									updatedRow["vacationPayAccured"] = Math.round(calculatedValue * 100) / 100;
								} else {
									updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = Math.round(calculatedValue * 100) / 100;
								}
							} else if (column.field === 'ot2Dot0Hours') {
								const regularHoursValue = rowData.regularHours && rowData.regularHours !== null ? rowData.regularHours * rowData.hourlyRate : 0;
								const ot1Dot5HoursValue = rowData.ot1Dot5Hours && rowData.ot1Dot5Hours !== null ? rowData.ot1Dot5Hours * rowData.hourlyRate * 1.5 : 0;
								let grossValue = (value * rowData.hourlyRate * 2.0) + regularHoursValue + ot1Dot5HoursValue
								const calculatedValue = (grossValue * 4) / 100;
								if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
									// existing Value or saved employee vac due value
									const initialRowValue = rows && rows.find((x: any) => x.employeeId === rowData.employeeId)
									const existingValue = Number(initialRowValue.vacationPayAccured) || 0;
									const newValue = existingValue + calculatedValue;
									updatedRow["vacationPayAccured"] = Math.round(calculatedValue * 100) / 100;
								} else {
									updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = Math.round(calculatedValue * 100) / 100;
								}
							}
						}
						updatedData[rowIndex] = updatedRow;
						setSelectedItems((prevSelected: any[]) =>
							prevSelected
								.map((sel) => updatedData.find((r) => r.employeeId === sel.employeeId))
								.filter(Boolean)
						);
						return updatedData;
					});

				} else {
					const isVocationable = allVocationableEarningsListOfThisEmployeeProvince.includes(column.field);

					setOffCyclePayrollItems((prev: any[]) => {
						const updatedData = [...prev];
						const updatedRow = { ...updatedData[rowIndex] };


						// always update the edited field first
						updatedRow[column.field] = value;

						if (isVocationable) {
							// 1️⃣ Sum all vocational field values (including this one)
							let totalSum = 0;

							// allVocationableEarningsListOfThisEmployeeProvince.forEach((vocField: string | number) => {
						
							// 	const fieldValue =
							// 		vocField === column.field
							// 			? value
							// 			: Number(updatedRow[vocField]) || 0;
							// 	totalSum += fieldValue;
						
							// });
							

							// // 2️⃣ Calculate 4% of total
							// const calculatedValue = (totalSum * 4) / 100;


							const notAllowedFields = ["regularHours", "ot1Dot5Hours", "ot2Dot0Hours"];

							allVocationableEarningsListOfThisEmployeeProvince.forEach((vocField: string) => {
								// ⛔ Ignore not allowed fields completely
								if (notAllowedFields.includes(vocField)) return;

								const fieldValue =
									vocField === column.field
										? Number(value) || 0
										: Number(updatedRow[vocField]) || 0;

								totalSum += fieldValue;
							});
							const regularHoursValue = rowData.regularHours && rowData.regularHours !== null ? rowData.regularHours * rowData.hourlyRate : 0;
							const ot1Dot5HoursValue = rowData.ot1Dot5Hours && rowData.ot1Dot5Hours !== null ? rowData.ot1Dot5Hours * rowData.hourlyRate * 1.5 : 0;
							const ot2Dot0HoursValue = rowData.ot2Dot0Hours && rowData.ot2Dot0Hours !== null ? rowData.ot2Dot0Hours * rowData.hourlyRate * 2.0 : 0;
							let grossValue = regularHoursValue + ot1Dot5HoursValue + ot2Dot0HoursValue + totalSum
							const calculatedValue = (grossValue * 4) / 100;


							
							if (updatedRow.hasOwnProperty("vacationPayAccured") && updatedRow["vacationPayAccured"] != null) {
								const vacationPayDueField = "vacationPayAccured";
								// const initialRowValue = rows && rows.find((x: any) => x.employeeId === rowData.employeeId)
								// // const existingValue = Number(updatedRow[vacationPayDueField]) || 0;
								// const existingValue = Number(initialRowValue.vacationPayAccured) || 0;
								// if (calculatedValue !== 0) {

								// 	const newValue = existingValue + calculatedValue;
							

								// 	// ✅ Round to 2 decimal places
								// 	updatedRow[vacationPayDueField] = Math.round(newValue * 100) / 100;
								// } else {
								// 	const initialRowValue = rows && rows.find((x: any) => x.employeeId === rowData.employeeId)
							
								// 	updatedRow[vacationPayDueField] = Math.round(initialRowValue.vacationPayAccured * 100) / 100;

								// }

								updatedRow[vacationPayDueField] = Math.round(calculatedValue * 100) / 100;


							} else {
								updatedRow["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] = Math.round(calculatedValue * 100) / 100;



								
								// const vacationPayDueField = "vacationPayAccured";
								// updatedRow[vacationPayDueField] = Math.round(calculatedValue * 100) / 100;
							}
						}

						// Update table data
						updatedData[rowIndex] = updatedRow;

						// Update selected items
						setSelectedItems((prevSelected: any[]) =>
							prevSelected
								.map((sel) => updatedData.find((r) => r.employeeId === sel.employeeId))
								.filter(Boolean)
						);

						return updatedData;
					});
				}
			} else {
				setOffCyclePayrollItems((prev: any[]) => {
					const updatedData = [...prev];
					const updatedRow = { ...updatedData[rowIndex], [column.field]: value };
					updatedData[rowIndex] = updatedRow;

					// Fix: re-map selectedItems to updatedData references
					setSelectedItems((prevSelected: any[]) =>
						prevSelected
							.map(sel => updatedData.find(r => r.employeeId === sel.employeeId))
							.filter(Boolean)
					);

					return updatedData;
				});
			}
		} else {
			setOffCyclePayrollItems((prev: any[]) => {
				const updatedData = [...prev];
				const updatedRow = updatedData[rowIndex];

				// mutate only the needed field (keeps same object reference)
				updatedRow[column.field] = value;

				return updatedData;
			});
		}
	};

	const columnsBody = (rowData: any, row: any, x: any) => {
		const value = getValueByFieldPath(rowData, x.field);
		if (x.isEditable && !rowData.salaryProfileMessage) {
			if (x.type === 'number') {
				return (
					<InputNumber
						value={value}
						// onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value, rowData)}
						onValueChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value, rowData)}
						// placeholder="0.00"
						minFractionDigits={2}
						maxFractionDigits={2}
						// inputClassName={`${x.field === 'vacationPay' ? "vacationPayField" : ""}`}
						inputClassName={
							x.field === 'vacationPay' ? 'vacationPayField' :
								x.field === 'holidayHours' ? 'holidayHoursField' :
									x.field === 'holidayPay' ? 'holidayHoursField' :
										x.field === 'holidayPayAccured' ? 'holidayHoursField' :
											x.edr === 'earnings' ? 'earningsField' :
												x.edr === 'deductions' ? 'deductionsField' :
													x.edr === 'reimbursements' ? 'reimbursementsField' :
														''}
						inputStyle={{ textAlign: "right" }}
						// onFocus={() => setActiveRowIndex(row.rowIndex)}
						onFocus={() => setActiveRowIndex(rowData.employeeId)}
					/>
				)
			} else if (!rowData.hasOwnProperty("vacationPayAccured") && rowData.hasOwnProperty("vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined") && rowData["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"] != null) {

				return (
					<Typography sx={{fontSize:".875rem"}} onClick={() => setActiveRowIndex(rowData.employeeId)}>
						{formatAmountCommaSeperator(rowData["vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined"])}
					</Typography>
				)
			} else {

				return (
					// <span onClick={() => setActiveRowIndex(rowData.employeeId)}>
					// 	{rowData[x.field]}
					// </span>
					<Typography sx={{fontSize:".875rem"}}  onClick={() => setActiveRowIndex(rowData.employeeId)}>
						{rowData[x.field]}
					</Typography>
				)
			}
		} else if (x.isEditable && rowData.salaryProfileMessage !== null && x.field === "regularHours") {
			return (
				// <span onClick={() => setActiveRowIndex(rowData.employeeId)}
				// 	className="salaryProfileMessage">
				// 	{rowData.salaryProfileMessage}
				// </span>
				<Typography sx={{fontSize:".875rem"}} onClick={() => setActiveRowIndex(rowData.employeeId)}
					className="salaryProfileMessage">
					{rowData.salaryProfileMessage}
				</Typography>
			)
		} else if (x.isEditable && rowData.salaryProfileMessage !== null && x.field !== "regularHours" && x.field !== "employeeName" && x.field !== "employeeNumberId") {
			return (
				<span onClick={() => setActiveRowIndex(rowData.employeeId)} style={{ display: "block" }}>&nbsp;</span>
			)
		} else {

			return (
				// <span onClick={() => setActiveRowIndex(rowData.employeeId)}>
				// 	{rowData[x.field]}
				// </span>
				<Typography sx={{fontSize:".875rem"}} onClick={() => setActiveRowIndex(rowData.employeeId)}>
					{rowData[x.field]}
				</Typography>
			)
		}
	};

	const containerRef = useRef<HTMLDivElement>(null);
	const [containerWidth, setContainerWidth] = useState(0);
	const [totalColumnWidth, setTotalColumnWidth] = useState(0);

	useEffect(() => {
		if (!containerRef.current) return;
		const observer = new ResizeObserver(([entry]) => {
			setContainerWidth(entry.contentRect.width);
		});
		observer.observe(containerRef.current);
		return () => observer.disconnect();
	}, []);
	useEffect(() => {
		// compute total defined width of all columns
		const totalColumnWidth = columns && columns.reduce(
			(sum: any, col: any) => sum + (col.maxWidth || 0),
			0
		);
		setTotalColumnWidth(totalColumnWidth)
	}, [columns]);




	// row highlighting (yellow background) when clicking any cell in that row
	const [activeRowIndex, setActiveRowIndex] = useState<number | null>(null);


	const getRowClassName = (data: any, options: any) => {
		return data.employeeId === activeRowIndex ? "highlighted-row" : "";
	};

	return (
		<div
			ref={containerRef}
			style={{
				width: "100%",
				overflow: "hidden", // container stays fixed
				background: "#fff"
			}}
		>
			<DataTable
				value={rows && columns && offCyclePayrollItems}
				responsiveLayout="scroll"
				// editMode={managedBy !== 100 ? "cell" : undefined} //non-editable for managed by simplepay
				showGridlines
				resizableColumns
				columnResizeMode="expand"
				scrollable
				scrollHeight={tableScrollHeight ? "75vh" : ""}
				// reorderableColumns
				loading={isLoading ? isLoading : loading}
				footer={footer ? footer : undefined}
				emptyMessage="No Record found."
				className="OffCyclePayrollDataGrid"
				style={{
					margin: `${tableMargin ? tableMargin : "14px 0.5rem 0.5rem 0"}`,
				}}
				selection={selectedItems}
				onSelectionChange={onSelectionModelChange}
				// selectionMode="multiple"
				selectionMode="checkbox"
				sortMode="single"
				/** 👇 Force fixed table layout so width styles are respected */
				// tableStyle={{ tableLayout: 'fixed', width: '100%' }}
				// tableStyle={{
				// 	tableLayout: 'fixed',
				// 	width: totalColumnWidth < containerWidth ? `${totalColumnWidth}px` : '100%',
				// }}
				tableStyle={{
					tableLayout: totalColumnWidth < containerWidth ? "fixed" : "auto",
					width: totalColumnWidth < containerWidth ? `${totalColumnWidth}px` : "100%"
				}}
				// onCellClick={(e) => alert("clicked")}
				rowClassName={getRowClassName}
				onSort={onSort}
			>
				{columns && rows && (
					<Column
						selectionMode="multiple"
						hidden={!showChecboxColumn}
						frozen
						resizeable={false}
						style={{ width: "36px", textAlign: "center" }}
						field="selection"
						columnKey="selection"
						className="selectionHeader"
						headerClassName="selectionHeader"
					></Column>
				)}
				{columns &&
					columns
						.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
						.map((x: any, index: any) => {
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									headerTooltip={x.description}
									headerTooltipOptions={{ position: "top" }}
									hidden={x.hide}
									sortable={x.sortable}
									reorderable={false}
									dataType={x.type}
									align={x.align}
									alignHeader={x.headerAlign}
									exportable={x.disableExport}
									frozen={totalColumnWidth < containerWidth ? false : x.frozenColumn}
									alignFrozen={x.alignFrozen}
									columnKey={x.field}
									style={{
										minWidth: x.minWidth,
										fontSize: "0.875rem",
										width: x.maxWidth,
										maxWidth: x.maxWidth,
										// width: x.maxWidth,
									}}

									headerStyle={{
										whiteSpace: whiteSpace ? whiteSpace : "nowrap",
									}}
									headerClassName={
										x.field === 'vacationPay' ? 'vacationPayField' :
											x.field === 'vacationPayAccured' ? 'vacationPayField' :
												x.field === 'holidayHours' ? 'holidayHoursField' :
													x.field === 'holidayPayAccured' ? 'holidayHoursField' :
														x.field === 'holidayPay' ? 'holidayHoursField' :
															x.edr === 'earnings' ? 'earningsField' :
																x.edr === 'deductions' ? 'deductionsField' :
																	x.edr === 'reimbursements' ? 'reimbursementsField' :
																		''}
									// className={
									// 	x.field === 'vacationPay' ? 'vacationPayField' :
									// 		x.field === 'vacationPayAccured' ? 'vacationPayField' :
									// 			x.field === 'holidayHours' ? 'holidayHoursField' :
									// 				x.field === 'holidayPayAccured' ? 'holidayHoursField' :
									// 					x.field === 'holidayPay' ? 'holidayHoursField' :
									// 						x.edr === 'earnings' ? 'earningsField' :
									// 							x.edr === 'deductions' ? 'deductionsField' :
									// 								x.edr === 'reimbursements' ? 'reimbursementsField' :
									// 									''}
									bodyClassName={(rowData: any, row: any) =>
										x.field === "vacationPay" && !rowData.salaryProfileMessage
											? "vacationPayField"
											: x.field === "vacationPayAccured" && !rowData.salaryProfileMessage
												? "vacationPayField"
												: x.field === "holidayHours" && !rowData.salaryProfileMessage
													? "holidayHoursField"
													: x.field === "holidayPayAccured" && !rowData.salaryProfileMessage
														? "holidayHoursField"
														: x.field === "holidayPay" && !rowData.salaryProfileMessage
															? "holidayHoursField"
															: x.edr === "earnings" && !rowData.salaryProfileMessage
																? "earningsField"
																: x.edr === "deductions" && !rowData.salaryProfileMessage
																	? "deductionsField"
																	: x.edr === "reimbursements" && !rowData.salaryProfileMessage
																		? "reimbursementsField"
																		: ""
									}

									footer={x.footer}
									body={(rowData: any, row: any) =>
										columnsBody(rowData, row, x)
									}
								/>
							);
						})}
			</DataTable>
		</div>
	);
};
